import React from 'react'
import HeroSection from '../../components/HeroSection'
import CompanySection from '../../components/Companies'
import Job from '../jobs/Job'
import SkillSmartSection  from '../../components/SkillSmartSection '
import Faq from '../faq/Faq'
import Testimonial from '../testimonials/Testimonials'
import Courses from '../courses/Courses'


const Home = () => {
  return (
    <div>
      
      <HeroSection />
       <CompanySection />
      
       <Job />
        <SkillSmartSection  />
       <Courses/>
       <Faq />
       <Testimonial />
    </div>
  )
}

export default Home
